export class CommandHandlerService {
  static __instance = null;

  static getInstance() {
    return CommandHandlerService.__instance || (CommandHandlerService.__instance = new CommandHandlerService());
  }

  constructor() {
    this.handlers = [];
  }

  registerHandler(handler) {
    this.handlers.push(handler);
  }

  hasHandler(command) {
    return this.handlers.some((h) => h.command === command);
  }

  handleCommand(command, request, sender, sendResponse) {
    const handlers = this.handlers.filter((h) => h.command === command);

    for (let handler of handlers) {
      handler.handle(request, sender, sendResponse);
    }
  }
}

export const commandHandlerService = CommandHandlerService.getInstance();



// WEBPACK FOOTER //
// ./src/services/commandHandlerService.js